export default __webpack_public_path__ + "static/media/celular-app.56912de2.png";